export enum GITHUB_REPOS_GET{
    START,
    SUCCESS,
    FAIL
}